import React, { useRef, useState } from 'react';
import { Form, Button, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';

import { authorizedPost } from '../api-authorization/AuthorizedFetch';
import { safeParseResponse } from '../../utils';

const NewStudentForm = ({ isOpen, toggle, classId, onSave }) => {
  const emailRef = useRef();
  
  const [validations, setValidations] = useState([]);

  const addStudent = async () => {
    const response = await authorizedPost(`api/classes/${classId}/students`, {
      userEmail: emailRef.current?.value
    });

    const parsedResponse = await safeParseResponse(response);

    if(response?.status === 400) {
      setValidations(parsedResponse);
    } else {
      toggle();
      onSave && onSave(parsedResponse);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Add a Student
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Student Email</Label>
            <Input innerRef={emailRef} invalid={validations?.length > 0} type="email" placeholder="abc@example.com" />
            {validations?.length > 0 && (
              <FormFeedback>{validations[0]}</FormFeedback>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={addStudent}
        >
          Add
        </Button>
        <Button onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default NewStudentForm;